import { MapPin } from 'lucide-react'
import { NativeSelect } from '@/components/ui/native-select'
import { useT } from '@/components/visitone/visitone-provider'
import type { Venue } from '@/lib/bff/today'

/*
 * Venue scope control for the Today header. The selected venue applies to every
 * module and persists per user across sessions (held by VenueScopeProvider).
 */
export function VenueSelector({
  venues,
  value,
  onChange,
}: {
  venues: Venue[]
  value: string
  onChange: (venueId: string) => void
}) {
  const t = useT()
  return (
    <div className="inline-flex items-center gap-2">
      <MapPin aria-hidden="true" className="size-4 text-fg-muted" />
      <label>
        <span className="sr-only">{t('today.venueScope.label')}</span>
        <NativeSelect
          value={value}
          onChange={(event) => onChange(event.target.value)}
          className="h-10 w-48"
        >
          {venues.map((venue) => (
            <option key={venue.id} value={venue.id}>
              {venue.name}
            </option>
          ))}
        </NativeSelect>
      </label>
    </div>
  )
}
